import { axInst } from "../../../Components/Login/Service";

export const mtd_stock = async (body) => {
  try {
    const res = await axInst.post("stocks/mtd-stocks", body);
    return res.data.MTD_STOCKS.value;
  } catch (error) {
    console.error(error);
  }
};

export const today_stock = async (body) => {
  try {
    const res = await axInst.post("stocks/ytd-stocks", body);
    return res.data.YTD_STOCKS.value;
  } catch (error) {
    console.error(error);
  }
};

export const total_stock = async (body) => {
  try {
    const res = await axInst.post("stocks/total-stocks", body);
    return res.data.TOTAL_STOCKS.value;
  } catch (error) {
    console.error(error);
  }
};
